import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SignalRService } from './common/services/signalr.service';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { LipoMessageService } from './common/services/LipoMessageService';
import { TranslateService } from '@ngx-translate/core';
import { filter, take } from 'rxjs/operators';
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import timelinePlugin from '@fullcalendar/timeline';
import listPlugin from '@fullcalendar/list';
import { PrimeNG } from 'primeng/config';
import { Observable, of } from 'rxjs';
import { AuthService, EnvironmentService } from 'FoxxyLib';
import { ILieferantenPortalEnvironment, ISortimentierenEnvironment } from 'FoxxyInterfaces';
import { AsyncPipe, CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
import { ShellModule } from './shell/shell.module';



@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports:[AsyncPipe, ToastModule, CommonModule, FormsModule,ShellModule],
    providers: [MessageService, LipoMessageService],
    standalone: true
})
export class AppComponent implements OnInit {


  calendarOptions: CalendarOptions = {
    plugins: [
      dayGridPlugin,
      timeGridPlugin,
      interactionPlugin,
      resourceTimelinePlugin,
      timelinePlugin,
      listPlugin
    ],
     initialView: 'dayGridMonth',
   }


  title = 'LiPoFrontend';
  /**CSS Klassen an die komplette App über geben
   * body damit versorgen
   */
  mainCSSClasses = "size_1_rem_light";

  isLoggedIn$ : Observable<boolean> = of (false) ;
  signalservice: SignalRService;

  changeCSSClasses($event: string) : void
  {
    this.mainCSSClasses = $event;
  }

  get claims() {
    return this.authService.claims;
  }

  constructor( private authService: AuthService,
    private signlarService : SignalRService,
    private messageService : MessageService,
    private lipomessageService : LipoMessageService<ToastMessageOptions>,
    private primeConfig: PrimeNG,
    private translateService: TranslateService,
    private router: Router,

    ) {

      this.isLoggedIn$ = this.authService.isAuthenticated$;



  }


  ngOnInit() {
    // GA** Navigate to saved returnUrl after OAuth login
    this.authService.isAuthenticated$.pipe(
      filter(isAuthenticated => isAuthenticated === true),
      take(1)
    ).subscribe(() => {
      const returnUrl = sessionStorage.getItem('returnUrl');
      if (returnUrl) {
        sessionStorage.removeItem('returnUrl');
        console.log(`Navigating to returnUrl: ${returnUrl}`);
        // Use setTimeout to ensure router is ready
        setTimeout(() => {
          this.router.navigateByUrl(returnUrl).then(success => {
            if (success) {
              console.log(`Successfully navigated to: ${returnUrl}`);
            } else {
              console.error(`Navigation failed to: ${returnUrl}`);
            }
          }).catch(error => {
            console.error(`Navigation error: ${error}`);
          });
        }, 100);
      }
    });

    this.lipomessageService.SubMessage.pipe(filter(f=> f != undefined && f.severity != undefined && f.summary != undefined)).subscribe(message =>
      {
          this.messageService.add(message);
      });
      this.primeConfig.setTranslation({
            dayNames: [ 'Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag' ],
            dayNamesShort: [ 'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa' ],
            dayNamesMin: [ 'S', 'M', 'D', 'M', 'D', 'F', 'S' ],
            monthNames: [ 'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember' ],
            monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez' ],
            today: 'Heute',
            clear: 'Löschen',
            noFilter: 'Filter entfernen'
      });
      this.translateService.setDefaultLang('de');
      this.signlarService.init(this.authService);
   }

   translate(lang: string) {
     this.translateService.use(lang);
     this.translateService.get('primeng').subscribe(res => this.primeConfig.setTranslation(res));
   }

}
